(() => {
  function initialize(root = document) {
    // Obfuscation deters simple HTML scrapers; it is not encryption.
    // Contact-page links remain usable if JavaScript is unavailable.
    root.querySelectorAll('[data-ss-contact]').forEach(link => {
      try {
        const address = atob(link.dataset.ssContact);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) return;
        link.setAttribute('href', 'mailto:' + address);
        if (link.hasAttribute('data-ss-contact-label')) link.textContent = address;
      } catch (_) {
        // Keep the contact-page fallback if the encoded value is invalid.
      }
    });
    root.querySelectorAll('[data-review][data-original]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const label = button.innerHTML;
      const image = document.createElement('img');
      image.className = 'ss-review-original';
      image.alt = 'Original customer review screenshot';
      image.src = button.dataset.original;
      image.hidden = true;
      image.loading = 'lazy';
      button.after(image);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => {
        image.hidden = !image.hidden;
        button.setAttribute('aria-expanded', String(!image.hidden));
        button.innerHTML = image.hidden ? label : 'Hide original review';
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
